import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders, getHeadersWithFormData } from '../../common/utils/utils';
import { postTypes } from '../../components/appCommon.constants';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { getAxiosCancelTokenSource } from '../../app.utils';

const networkPageState = () => {
    return {
        baseURL: process.env.VUE_APP_BASE_URL,
        relatedCommunitiesList_canEdit: null,
        relatedCommunitiesList: [],
        updateRelatedCommuinty: [],
        subNetworkList: [],
        requestedJoineeList: [],
        resultApproveRequest: null,
        selectedPostType: postTypes.ALL_POSTS,
        inviteeList: [],
        allNetworks: '',
        toggleRequestedMembers: false,
        toggleRequestedGroups: false,
        toggleManageParticipants: false,
        toggleConfigureGroup: false,
        toggleInviteSomeone: false,
        togglePendingAssetRequests: false,
        joinNetwork: '',
        ypoNetworks: null,
        returnInviteesList: [],
        parentNetworkName: '',
        selectedNetwork: [],
        communityPendingRequests: [],
        verifiedMembers: [],
        viewPendingAssetRequest: false,
        networkPageContent: {},
    };
};

const networkPageMutations = {
    [storeMutation.setRelatedCommunities]: (state, data) => {
        state.relatedCommunitiesList_canEdit = data.canEdit;
        state.relatedCommunitiesList = data.relatedCommunities;
    },
    [storeMutation.setCommunityPendingRequests]: (state, data) => {
        state.communityPendingRequests = data;
    },
    [storeMutation.toggleRequestedMembers]: (state, data) => {
        state.toggleRequestedMembers = data;
        state.toggleInviteSomeone = false;
        state.toggleManageParticipants = false;
        state.toggleConfigureGroup = false;
        state.toggleRequestedGroups = false;
        state.togglePendingAssetRequests = false;
    },
    [storeMutation.toggleRequestedGroups]: (state, data) => {
        state.toggleRequestedGroups = data;
        state.toggleRequestedMembers = false;
        state.toggleInviteSomeone = false;
        state.toggleManageParticipants = false;
        state.toggleConfigureGroup = false;
        state.togglePendingAssetRequests = false;
    },
    [storeMutation.toggleInviteSomeone]: (state, data) => {
        state.toggleInviteSomeone = data;
        state.toggleRequestedMembers = false;
        state.toggleManageParticipants = false;
        state.toggleConfigureGroup = false;
        state.toggleRequestedGroups = false;
        state.togglePendingAssetRequests = false;
    },
    [storeMutation.toggleManageParticipants]: (state, data) => {
        state.toggleManageParticipants = data;
        state.toggleRequestedMembers = false;
        state.toggleInviteSomeone = false;
        state.toggleConfigureGroup = false;
        state.toggleRequestedGroups = false;
        state.togglePendingAssetRequests = false;
    },
    [storeMutation.toggleConfigureGroup]: (state, data) => {
        state.toggleConfigureGroup = data;
        state.toggleRequestedMembers = false;
        state.toggleInviteSomeone = false;
        state.toggleManageParticipants = false;
        state.toggleRequestedGroups = false;
        state.togglePendingAssetRequests = false;
    },
    [storeMutation.togglePendingAssetRequests]: (state) => {
        state.toggleConfigureGroup = false;
        state.toggleRequestedMembers = false;
        state.toggleInviteSomeone = false;
        state.toggleManageParticipants = false;
        state.toggleRequestedGroups = false;
        state.togglePendingAssetRequests = true;
    },
    [storeMutation.setRelatedCommunityMsg]: (state, data) => {
        state.relatedCommunitiesList.push(data);
    },

    [storeMutation.deleteRelatedCommunity]: (state, relatedCommunityID) => {
        const relatedCommunity = state.relatedCommunitiesList.find(item => item.id === relatedCommunityID);
        if (relatedCommunity) {
            state.relatedCommunitiesList.splice(state.relatedCommunitiesList.indexOf(relatedCommunity), 1);
        }
    },
    [storeMutation.setupdateRelatedCommunity]: (state, data) => {
        const index = state.relatedCommunitiesList.findIndex(item => item.id === data.id);
        state.relatedCommunitiesList[index].title = data.title;
        state.relatedCommunitiesList[index].url = data.url;
    },

    [storeMutation.setSubNetworks]: (state, data) => {
        state.subNetworkList = data.subNetworks;
    },

    [storeMutation.setAllNetworks]: (state, data) => {
        state.allNetworks = data;
    },

    [storeMutation.setRequestedJoinees]: (state, data) => {
        if (data && data.length > 0) {
            data.forEach((d) => {
                d.approvalInProgress = false;
            });
        }
        state.requestedJoineeList = data;
    },
    [storeMutation.setApproveRequest]: (state, data) => {
        state.resultApproveRequest = data;
    },
    [storeMutation.setSelectedPostType]: (state, data) => {
        state.selectedPostType = data;
    },
    [storeMutation.setSelectedNetwork]: (state, data) => {
        state.selectedNetwork = data;
    },
    [storeMutation.setInviteeesList]: (state, data) => {
        state.inviteeList = data;
    },
    [storeMutation.setApplytoJoinNetwork]: (state, data) => {
        state.joinNetwork = data;
    },
    [storeMutation.setYPONetworks]: (state, data) => {
        state.ypoNetworks = data;
    },

    [storeMutation.setReturnInviteesList]: (state, data) => {
        state.returnInviteesList = data;
    },
    [storeMutation.setVerifiedMembers]: (state, data) => {
        if (data) {
            data.forEach((element) => {
                if (!state.verifiedMembers.some(item => item.name === element.name)) {
                    state.verifiedMembers.push(element);
                }
            });
        }
    },
    [storeMutation.clearVerifiedMembers]: (state) => {
        state.verifiedMembers = [];
    },
    [storeMutation.clearVerifiedMembers]: (state) => {
        state.verifiedMembers = [];
    },
    [storeMutation.setViewPendingAssetRequest]: (state, data) => {
        state.viewPendingAssetRequest = data;
    },
    [storeMutation.setNetworkPageContent]: (state, data) => {
        state.networkPageContent = data;
    },
};

const networkPageActions = {
    [storeAction.applyToJoinNetwork]: ({ state, rootGetters, commit }, objApplytojoin) => {
        const communityType = rootGetters[storeGetters.communityName].toLowerCase();
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/communities/${communityType}/join`,
                headers: getBasicHeaders(),
                data: { ...objApplytojoin },
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setApplytoJoinNetwork, response.data);
                    if (response.data) {
                        resolve(response);
                    } else {
                        reject();
                    }
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.resignFromCommunity]: ({ state, rootGetters }, CommunityId) => {
        const communityType = rootGetters[storeGetters.communityName].toLowerCase();
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/communities/${communityType}/resign`,
                headers: getBasicHeaders(),
                data: { CommunityId },
                method: 'POST',
            })
                .then((response) => {
                    if (response.data) {
                        resolve(response);
                    } else {
                        reject();
                    }
                })
                .catch((err) => {
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.getRelatedCommunities]: async ({ state, commit, rootGetters }) => {
        const communityId = await rootGetters[storeGetters.communityIdPromise];
        const communityType = rootGetters[storeGetters.communityName];
        commit(storeMutation.setRelatedCommunities, { canEdit: false, relatedCommunities: [] });
        return new Promise((resolve, reject) => {
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getRelatedCommunities,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

            axios({
                url: `${state.baseURL}communities/api/relatedCommunities/list/${communityType}/${communityId}`,
                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getRelatedCommunities, { root: true });
                    commit(storeMutation.setRelatedCommunities, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.createRelatedCommunity]: async ({ state, commit, rootGetters }, objectToSave) => {
        const communityId = await rootGetters[storeGetters.communityIdPromise];
        const communityTypeName = rootGetters[storeGetters.communityName];
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/relatedCommunities/create/${communityTypeName}/${communityId}`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setRelatedCommunityMsg, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.updateRelatedCommunity]: async ({ state, commit, rootGetters }, obj) => {
        const communityId = await rootGetters[storeGetters.communityIdPromise];
        const communityTypeName = rootGetters[storeGetters.communityName];
        return axios({
            url: `${state.baseURL}communities/api/relatedCommunities/update/${communityTypeName}/${
                obj.communityId
            }/${communityId}`,
            headers: getBasicHeaders(),
            data: { ...obj.newCommunity },
            method: 'PUT',
        })
            .then((response) => {
                commit(storeMutation.setupdateRelatedCommunity, response.data);
                return response;
                //resolve(response);
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
                // reject(err);
            });
    },

    //reorder Related community list
    [storeAction.saveReorderedRelatedCommunities]: async ({ state, rootGetters }, obj) => {
        const communityId = await rootGetters[storeGetters.communityIdPromise];
        const communityTypeName = rootGetters[storeGetters.communityName];

        return axios({
            url: `${state.baseURL}communities/api/relatedCommunities/reorder/${communityTypeName}/${communityId}`,
            headers: getBasicHeaders(),
            data: obj,
            method: 'PUT',
        })
            .then((response) => {
                //  commit(storeMutation.updateFeatureEvents, response.data);
                return response;
                //resolve(response);
            })
            .catch((err) => {
                //TODO: handle error
                console.log(err);
                // reject(err);
            });
    },
    //sub networks list of data
    [storeAction.getSubNetworksData]: wrapAction(
        storeAction.getSubNetworksData,
        async ({ state, commit, rootGetters }) => {
            const communityId = await rootGetters[storeGetters.communityIdPromise];
            return new Promise((resolve, reject) => {
                const requestSource = getAxiosCancelTokenSource();
                const requestObject = {
                    actionName: storeAction.getSubNetworksData,
                    requestSource,
                };
                commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

                axios({
                    url: `${state.baseURL}communities/api/communities/subnetworks/${communityId}`,
                    headers: getBasicHeaders(),
                    method: 'GET',
                    cancelToken: requestSource.token,
                })
                    .then((response) => {
                        commit(storeMutation.setSubNetworks, { subNetworks: response.data });
                        commit(storeMutation.removeCancelableRequest, storeAction.getSubNetworksData, { root: true });
                        resolve(response);
                    })
                    .catch((err) => {
                        //TODO: handle error
                        console.log(err);
                        reject(err);
                    });
            });
        },
    ),
    [storeAction.getCommunityPendingRequests]: async ({ state, commit, rootGetters }) => {
        const communityType = await rootGetters[storeGetters.communityName].toLowerCase();
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/communities/${communityType}/join/pending-request`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setCommunityPendingRequests, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    commit(storeMutation.setCommunityPendingRequests, []);
                    reject(err);
                });
        });
    },

    [storeAction.getNetworkPageContent]: ({ state, commit }, communityId) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/networkPageContent/${communityId}`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setNetworkPageContent, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    },
    //GET All Network Joinee list
    [storeAction.getAllRequestedJoinees]: async ({ state, commit, rootGetters }) => {
        const communityId = await rootGetters[storeGetters.communityIdPromise];
        const communityType = await rootGetters[storeGetters.communityName].toLowerCase();
        const requestSource = getAxiosCancelTokenSource();
        const requestObject = {
            actionName: storeAction.getAllRequestedJoinees,
            requestSource,
        };
        commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/communities/${communityType}/join/requests/${communityId}`,
                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.setRequestedJoinees, response.data);
                    commit(storeMutation.removeCancelableRequest, storeAction.getAllRequestedJoinees, { root: true });
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },

    [storeAction.getAllNetworks]: wrapAction(storeAction.getAllNetworks, ({ state, commit }) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/ypolandingnetworks`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setAllNetworks, response.data);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),

    //Approve or Deny Request
    [storeAction.approveRequest]: ({ state, rootGetters, commit }, objectToSave) => {
        const communityType = rootGetters[storeGetters.communityName].toLowerCase();
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/communities/${communityType}/join/review`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setApproveRequest, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },

    [storeAction.deleteRelatedCommunity]: async ({ state, rootGetters, commit }, relatedCommunityId) => {
        const communityId = await rootGetters[storeGetters.communityIdPromise];
        const communityType = rootGetters[storeGetters.communityName].toLowerCase();
        return new Promise((resolve, reject) => {
            axios({
                url: `${
                    state.baseURL
                }communities/api/relatedCommunities/${communityType}/${relatedCommunityId}/${communityId}`,
                headers: getBasicHeaders(),
                method: 'DELETE',
            })
                .then((response) => {
                    commit(storeMutation.deleteRelatedCommunity, relatedCommunityId);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },

    [storeAction.getInviteesList]: wrapAction(storeAction.getInviteesList, ({ state, commit }, searchObject) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}profiles/api/memberdirectory`,
                headers: getBasicHeaders(),
                data: searchObject,
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setInviteeesList, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    }),

    //YPO NET Works list
    [storeAction.getYPONetworks]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            const requestSource = getAxiosCancelTokenSource();
            const requestObject = {
                actionName: storeAction.getYPONetworks,
                requestSource,
            };
            commit(storeMutation.handleCancelableRequest, requestObject, { root: true });

            axios({
                url: `${state.baseURL}communities/api/communities/yponetworks`,
                headers: getBasicHeaders(),
                method: 'GET',
                cancelToken: requestSource.token,
            })
                .then((response) => {
                    commit(storeMutation.removeCancelableRequest, storeAction.getYPONetworks, { root: true });
                    commit(storeMutation.setYPONetworks, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.saveYpoNetworkCategories]: wrapAction(storeAction.saveYpoNetworkCategories, ({ state, commit }, requestBody) => {
        const requestData = requestBody ;
        return axios({
            url: `${state.baseURL}communities/api/communities/saveNetworkPageContent`,
            headers: getBasicHeaders(),
            data: requestData,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setNetworkPageContent, Object.create(response.data));
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    }),
    [storeAction.modifyDisplayOrderNetworkCategories]: wrapAction(storeAction.modifyDisplayOrderNetworkCategories, ({ state, commit }, requestBody) => {
        const requestData = requestBody ;
        return axios({
            url: `${state.baseURL}communities/api/communities/saveNetworkPageContentDisplayOrder`,
            headers: getBasicHeaders(),
            data: requestData,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setNetworkPageContent, Object.create(response.data));
                return response.data;
            })
            .catch((err) => {
                console.log(err);
                throw err.response.data;
            });
    }),

    [storeAction.updateRelatedContentData]: async ({ state, commit, rootGetters }, formData) => {
        return axios({
            url: `${state.baseURL}communities/api/communities/SaveNetworkPageRelatedContent`,
            headers: getHeadersWithFormData(),
            data: formData,
            method: 'POST',
        })
            .then((response) => {
                commit(storeMutation.setNetworkPageContent, response.data);
                console.log(response.data);
                return true;
            })
            .catch((err) => {
                console.log(err);
                state.fileUploadPercentage = 0;
                throw err;
            });
    },
    [storeAction.verifyEmailExitsinDB]: ({ state, commit }, objectToSave) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/communities/person-search/by-emailIds`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'POST',
            })
                .then((response) => {
                    commit(storeMutation.setVerifiedMembers, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },

    //sending invitees members list
    [storeAction.sendInviteesList]: ({ state, rootGetters }, objectToSave) => {
        const communityType = rootGetters[storeGetters.communityName].toLowerCase();
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}communities/api/communities/${communityType}/invite`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'POST',
            })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
    [storeAction.canViewPendingAssetRequest]: ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            axios({
                url: `${state.baseURL}profiles/api/around-me/can-view-pending-asset-request`,
                headers: getBasicHeaders(),
                method: 'GET',
            })
                .then((response) => {
                    commit(storeMutation.setViewPendingAssetRequest, response.data);
                    resolve(response);
                })
                .catch((err) => {
                    //TODO: handle error
                    console.log(err);
                    reject(err);
                });
        });
    },
};

const networkPageGetters = {
    [storeGetters.relatedCommunitiesList]: state => state.relatedCommunitiesList,
    [storeGetters.getRequestedMembers]: state => state.toggleRequestedMembers,
    [storeGetters.getRequestedGroups]: state => state.toggleRequestedGroups,
    [storeGetters.getInviteSomeOne]: state => state.toggleInviteSomeone,
    [storeGetters.getManageParticipants]: state => state.toggleManageParticipants,
    [storeGetters.getConfigureGroup]: state => state.toggleConfigureGroup,
    [storeGetters.updateRelatedCommuinty]: state => state.updateRelatedCommuinty,
    [storeGetters.subNetworkList]: state => state.subNetworkList,
    [storeGetters.requestedJoineeList]: state => state.requestedJoineeList,
    [storeGetters.resultApproveRequest]: state => state.resultApproveRequest,
    [storeGetters.getSelectedPostType]: state => state.selectedPostType,
    [storeGetters.inviteeList]: state => state.inviteeList,
    [storeGetters.ypoNetworks]: state => state.ypoNetworks,
    [storeGetters.returnInviteesList]: state => state.returnInviteesList,
    [storeGetters.canEditRelatedCommunities]: state => state.relatedCommunitiesList_canEdit,
    [storeGetters.getSelectedNetwork]: state => state.selectedNetwork,
    [storeGetters.communityPendingRequests]: state => state.communityPendingRequests,
    [storeGetters.verifiedMembers]: state => state.verifiedMembers,
    [storeGetters.viewPendingAssetRequest]: state => state.viewPendingAssetRequest,
    [storeGetters.togglePendingAssetRequests]: state => state.togglePendingAssetRequests,
    [storeGetters.allNetworks]: state => state.allNetworks,
    [storeGetters.networkPageContent]: state => state.networkPageContent,
};

export default {
    namespaced: true,
    state: {
        initialState: networkPageState(),
        ...networkPageState(),
    },
    mutations: { ...networkPageMutations },
    actions: { ...networkPageActions },
    getters: { ...networkPageGetters },
};
